export const baseUrl = 'https://loyalty.hafele.api.wemonde.co/api/v1/' //staging
export const av = "1.0";
export const pt = "WEBSITE";
export const company = "1";
export const program = "1";